import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录"
    },
    component: () => import("@/views/login/login"),
    hidden: true
  },
  {
    path: "/wxlogin",
    name: "wxlogin",
    meta: {
      title: "登录"
    },
    component: () => import("@/views/login/wxlogin"),
    hidden: true
  },
  {
    path: "/404",
    meta: {
      title: "404"
    },
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/individualRanking",
    name: "IndividualRanking",
    meta: {
      title: "报表首页"
    },
    component: () => import("@/views/individualRanking"),
    hidden: true
  },
  {
    path: "/overseasGoodsDetail",
    name: "OverseasGoodsDetail",
    meta: {
      title: "商品详情"
    },
    component: () => import("@/views/overseasGoodsDetail"),
    hidden: true
  }
];

export const asyncRouterMap = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    name: "Home",
    meta: {
      title: "首页",
      roles: ["editor", "admin", "activityEditor", "activityAdmin"]
    },
    hidden: true,
    children: [
      {
        path: "home",
        component: () => import("@/views/home/home"),
        meta: {
          title: "首页",
          roles: ["editor", "admin", "activityEditor", "activityAdmin"]
        }
      }
    ]
  },
  {
    path: "/reservation",
    component: Layout,
    redirect: "/reservation/appointment",
    name: "Reservation",
    meta: {
      title: "预约服务管理",
      icon: "icon-fuwuzhongxin",
      roles: ["editor"]
    },
    children: [
      {
        path: "/reservation/appointment",
        component: () => import("@/views/reservation/appointment/index"),
        redirect: "/appointment/appointmentList",
        name: "Appointment",
        meta: {
          title: "预约管理",
          // icon: "icon-leijiyuyue",
          roles: ["editor"]
        },
        children: [
          {
            path: "appointmentList",
            name: "AppointmentList",
            component: () =>
              import("@/views/reservation/appointment/appointmentList"),
            meta: {
              title: "预约列表",
              roles: ["editor"]
            }
          },
          {
            path: "appointmentCalendar",
            name: "AppointmentCalendar",
            component: () =>
              import("@/views/reservation/appointment/appointmentCalendar"),
            meta: {
              title: "预约日历",
              roles: ["editor"]
            }
          }
        ]
      },
      {
        path: "/reservation/storeAndStaff",
        redirect: "/reservation/storeAndStaff/storeList",
        component: () => import("@/views/reservation/storeAndStaff/index"),
        name: "StoreAndStaff",
        meta: {
          title: "门店与技师管理",
          // icon: "icon-mendian",
          roles: ["editor"]
        },
        children: [
          {
            path: "storeList",
            name: "StoreList",
            component: () =>
              import("@/views/reservation//storeAndStaff/storeList"),
            meta: {
              title: "门店列表",
              roles: ["editor"]
            }
          },
          {
            path: "serviceCategory",
            name: "ServiceCategory",
            component: () =>
              import("@/views/reservation//storeAndStaff/serviceCategory"),
            meta: {
              title: "服务分类列表",
              roles: ["editor"]
            }
          },
          {
            path: "serviceList",
            name: "ServiceList",
            component: () =>
              import("@/views/reservation//storeAndStaff/serviceList"),
            meta: {
              title: "项目列表",
              roles: ["editor"]
            }
          },
          {
            path: "addService",
            name: "AddService",
            hidden: true,
            component: () =>
              import("@/views/reservation//storeAndStaff/addService"),
            meta: {
              title: "新增项目",
              roles: ["editor"]
            }
          },
          {
            path: "editService",
            name: "EditService",
            hidden: true,
            component: () =>
              import("@/views/reservation//storeAndStaff/editService"),
            meta: {
              title: "编辑项目",
              roles: ["editor"]
            }
          },
          {
            path: "copyService",
            name: "CopyService",
            hidden: true,
            component: () =>
              import("@/views/reservation//storeAndStaff/copyService"),
            meta: {
              title: "复制项目",
              roles: ["editor"]
            }
          },
          {
            path: "staffList",
            name: "StaffList",
            component: () =>
              import("@/views/reservation//storeAndStaff/staffList"),
            meta: {
              title: "技师列表",
              roles: ["editor"]
            }
          }
        ]
      },
      {
        path: "/reservation/service",
        component: () => import("@/views/reservation/service/index"),
        redirect: "/reservation/service/productList",
        name: "Service",
        meta: {
          title: "服务商品管理",
          // icon: "icon-fuwuzhongxin",
          roles: ["editor"]
        },
        children: [
          {
            path: "productCategory",
            name: "ProductCategory",
            component: () =>
              import("@/views/reservation/service/productCategory"),
            meta: {
              title: "商品分类列表",
              roles: ["editor"]
            }
          },
          {
            path: "commodityList",
            name: "CommodityList",
            component: () =>
              import("@/views/reservation/service/commodityList"),
            meta: {
              title: "商品列表",
              roles: ["editor"]
            }
          },
          {
            path: "addCommodity",
            name: "AddCommodity",
            hidden: true,
            component: () => import("@/views/reservation/service/addCommodity"),
            meta: {
              title: "新增商品",
              roles: ["editor"]
            }
          },
          {
            path: "editCommodity",
            name: "EditCommodity",
            hidden: true,
            component: () =>
              import("@/views/reservation/service/editCommodity"),
            meta: {
              title: "编辑商品",
              roles: ["editor"]
            }
          },
          {
            path: "productList",
            name: "ProductList",
            component: () => import("@/views/reservation/service/productList"),
            meta: {
              title: "服务卡列表",
              roles: ["editor"]
            }
          },
          {
            path: "addProductList",
            name: "AddProductList",
            hidden: true,
            component: () =>
              import("@/views/reservation/service/addProductList"),
            meta: {
              title: "新增服务卡",
              roles: ["editor"]
            }
          },
          {
            path: "editProductList",
            name: "EditProductList",
            hidden: true,
            component: () =>
              import("@/views/reservation/service/editProductList"),
            meta: {
              title: "编辑服务卡",
              roles: ["editor"]
            }
          }
        ]
      },
      {
        path: "/reservation/orders",
        redirect: "/reservation/orders/ordersList",
        component: () => import("@/views/reservation/orders/index"),
        name: "Orders",
        meta: {
          title: "订单管理",
          // icon: "icon-dingdan",
          roles: ["editor"]
        },
        children: [
          {
            path: "ordersList",
            name: "OrdersList",
            component: () => import("@/views/reservation/orders/ordersList"),
            meta: {
              title: "订单列表",
              roles: ["editor"]
            }
          }
        ]
      },
      {
        path: "/reservation/member",
        component: () => import("@/views/reservation/member/index"),
        redirect: "/reservation//member/memberList",
        name: "Member",
        meta: {
          title: "会员管理",
          // icon: "icon-huiyuan",
          roles: ["editor"]
        },
        children: [
          {
            path: "memberList",
            name: "memberList",
            component: () => import("@/views/reservation/member/memberList"),
            meta: {
              title: "会员列表",
              roles: ["editor"]
            }
          },
          {
            path: "memberRecord",
            name: "MemberRecord",
            hidden: true,
            component: () => import("@/views/reservation/member/memberRecord"),
            meta: {
              title: "会员记录",
              roles: ["editor"]
            }
          }
        ]
      },
      {
        path: "/reservation/account",
        component: () => import("@/views/reservation/account/index"),
        redirect: "/account/account",
        name: "Account",
        meta: {
          title: "账号管理",
          // icon: "icon-xiugaimima",
          roles: ["editor"]
        },
        children: [
          {
            path: "account",
            name: "account",
            component: () => import("@/views/reservation/account/account"),
            meta: {
              title: "修改密码",
              roles: ["editor"]
            }
          }
        ]
      },
      {
        path: "/reservation/queue",
        component: () => import("@/views/reservation/queue/index"),
        redirect: "/queue/screenList",
        name: "Queue",
        meta: {
          title: "叫号平台管理",
          // icon: "icon-wodepaidui",
          roles: ["editor"]
        },
        children: [
          {
            path: "screenList",
            name: "ScreenList",
            component: () => import("@/views/reservation/queue/screenList"),
            meta: {
              title: "叫号大屏配置",
              roles: ["editor"]
            }
          },
          {
            path: "getNumRecord",
            name: "GetNumRecord",
            component: () => import("@/views/reservation/queue/getNumRecord"),
            meta: {
              title: "取号记录",
              roles: ["editor"]
            }
          },
          {
            path: "addScreen",
            name: "AddScreen",
            hidden: true,
            component: () => import("@/views/reservation/queue/addScreen"),
            meta: {
              title: "新增大屏配置",
              roles: ["editor"]
            }
          },
          {
            path: "editScreen",
            name: "EditScreen",
            hidden: true,
            component: () => import("@/views/reservation/queue/editScreen"),
            meta: {
              title: "编辑大屏配置",
              roles: ["editor"]
            }
          }
        ]
      }
    ]
  },
  {
    path: "/activity",
    component: Layout,
    redirect: "/activity/activityList",
    name: "Activity",
    meta: {
      title: "促销管理",
      icon: "icon-cuxiaoguanli",
      roles: ["activityEditor", "activityAdmin"]
    },
    children: [
      {
        path: "activityCheckRecord",
        name: "ActivityCheckRecord",
        component: () => import("@/views/activity/activityCheckRecord"),
        meta: {
          title: "促销审核列表",
          roles: ["activityAdmin"]
        }
      },
      {
        path: "activityDetails",
        name: "ActivityDetails",
        component: () => import("@/views/activity/activityDetails"),
        hidden: true,
        meta: {
          title: "促销详情",
          roles: ["activityAdmin", "activityEditor"]
        }
      },
      {
        path: "activityList",
        name: "ActivityList",
        component: () => import("@/views/activity/activityList"),
        meta: {
          title: "促销列表",
          roles: ["activityEditor"]
        }
      },
      {
        path: "cashierSetting",
        name: "CashierSetting",
        component: () => import("@/views/activity/cashierSetting"),
        meta: {
          title: "收银设置",
          roles: ["activityEditor"]
        }
      },
      {
        path: "selectActivity",
        name: "SelectActivity",
        component: () => import("@/views/activity/selectActivity"),
        hidden: true,
        meta: {
          title: "选择促销类型",
          roles: ["activityEditor"]
        }
      },
      {
        path: "creatActivity",
        name: "CreatActivity",
        component: () => import("@/views/activity/creatActivity"),
        hidden: true,
        meta: {
          title: "创建促销",
          roles: ["activityEditor"]
        }
      },
      {
        path: "goodsManagement",
        name: "GoodsManagement",
        component: () => import("@/views/activity/goodsManagement"),
        hidden: true,
        meta: {
          title: "商品管理",
          roles: ["activityEditor"]
        }
      },
      {
        path: "creatGoodsRule",
        name: "CreatGoodsRule",
        component: () => import("@/views/activity/creatGoodsRule"),
        hidden: true,
        meta: {
          title: "创建规则",
          roles: ["activityEditor"]
        }
      }
    ]
  },

  {
    path: "/event",
    component: Layout,
    redirect: "/event/eventList",
    name: "Event",
    meta: {
      title: "活动中心",
      icon: "icon-huodongzhongxin",
      roles: ["activityAdmin", "activityEditor", "editor"]
    },
    children: [
      {
        path: "eventList",
        name: "EventList",
        component: () => import("@/views/event/eventList"),
        meta: {
          title: "活动列表",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "viewReservitionList",
        name: "ViewReservitionList",
        hidden: true,
        component: () => import("@/views/event/viewReservitionList"),
        meta: {
          title: "查看预约列表",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "viewReservitionCouponManagerment",
        name: "ViewReservitionCouponManagerment",
        component: () =>
          import("@/views/event/viewReservitionCouponManagerment"),
        meta: {
          title: "预约活动发券管理",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "addEvent",
        name: "AddEvent",
        hidden: true,
        component: () => import("@/views/event/addEvent"),
        meta: {
          title: "新增活动",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "eventDetails",
        name: "EventDetails",
        hidden: true,
        component: () => import("@/views/event/eventDetails"),
        meta: {
          title: "活动详情",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "editEvent",
        name: "EditEvent",
        hidden: true,
        component: () => import("@/views/event/editEvent"),
        meta: {
          title: "活动详情",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "writeOffCenter",
        name: "WriteOffCenter",
        component: () => import("@/views/event/writeOffCenter"),
        meta: {
          title: "核销中心",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      }
    ]
  },
  {
    path: "/wakeUpMember",
    component: Layout,
    redirect: "/wakeUpMember/wakeUpMemberList",
    name: "WakeUpMember",
    meta: {
      title: "唤醒会员设置",
      icon: "icon-huanxing",
      roles: ["activityAdmin", "activityEditor", "editor"]
    },
    children: [
      {
        path: "wakeUpMemberList",
        name: "WakeUpMemberList",
        component: () => import("@/views/wakeUpMember/wakeUpMemberList"),
        meta: {
          title: "唤醒会员列表",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "guiderRewardList",
        name: "GuiderRewardList",
        component: () => import("@/views/wakeUpMember/guiderRewardList"),
        meta: {
          title: "导购积分奖励列表",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "guiderRewardDetails",
        name: "GuiderRewardDetails",
        component: () => import("@/views/wakeUpMember/guiderRewardDetails"),
        hidden: true,
        meta: {
          title: "积分奖励详情",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "wakeUpSetting",
        name: "WakeUpSetting",
        component: () => import("@/views/wakeUpMember/wakeUpSetting"),
        meta: {
          title: "会员唤醒设置",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      }
    ]
  },
  {
    path: "/system",
    component: Layout,
    redirect: "/system/roleUserList",
    name: "System",
    meta: {
      title: "系统管理",
      icon: "icon-xitong",
      roles: ["editor"]
    },
    children: [
      {
        path: "roleUserList",
        name: "RoleUserList",
        component: () => import("@/views/system/roleUserList"),
        meta: {
          title: "角色维护",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      },
      {
        path: "role",
        name: "Role",
        component: () => import("@/views/system/role"),
        meta: {
          title: "角色管理",
          roles: ["activityAdmin", "activityEditor", "editor"]
        }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

export default new Router({
  mode: "history", //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
